import { gridSize } from '@atlaskit/theme';

export const BANNER_HEIGHT = gridSize() * 44;
